angular.module('gc.custom-scrollbar', [])

.directive('customScrollbar', function() {
  return {
    restrict: 'A',
    link: function (scope, element, attrs) {
      var scrollbar = OverlayScrollbars(element[0], {
        scrollbars: {
          autoHide: 'move',
        },
        callbacks: {
          onScroll: function(event) {
            element.trigger('custom-scroll', event);
          }
        }
      });
      element.data('custom-scrollbar', scrollbar);
    }
  };
})

